<template>
  <section>
    <b-row>
      <b-col>
          <validation-observer v-slot="{ invalid }">
              <b-card           
                >   
                  <template v-slot:header >
                    <div class="header-card">
                      Registrar ordenes anteriores
                    </div>
                  </template>
                  <b-row>
                  <b-col :md="12" style="margin-top:10px">
                      <sw-tableget
                        :tableItems="tableGBItems"
                        :tableSearch="tableGBSearch"
                        :tableOptions="tableGBoptions"
                        name="tableGet"
                        route="antiguo_examens"
                        dataRoute="pacientes"
                        >
                        <template v-slot:modal>
                          <sw-modalregistroorden 
                            v-if="openModal.modal.modal==='registrar'"
                            @save="saveForm"                     
                            >
                          </sw-modalregistroorden>
                          <sw-modalanularexamen
                            v-if="openModal.modal.modal==='Anular'"
                            @save="saveForm"
                            >
                          </sw-modalanularexamen>  
                        </template>
                      </sw-tableget>                  
                  </b-col>              
                </b-row>             
                                                  
              </b-card>           
          </validation-observer>
      </b-col>
    </b-row>          
  </section>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalregistroorden from '@/components/modals/registroorden.vue'
import SwModalanularexamen from '@/components/modals/anularexamen.vue'

export default { 
  name: "forms_saveform",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
     ValidationObserver,
     SwTableget,
     SwModalregistroorden,
     SwModalanularexamen
  }
}
</script>
